export default "__VITE_ASSET__BFpwTj9n__"